import { useBrowserAgentSearchModeEnabled } from '#pplx/frontend/apps/ask/hooks/comet-hooks/useBrowserAgentSearchModeEnabled.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
/**
 * Determines if a search mode should be visible in the UI.
 * Only checks feature flags and org-level settings - NOT subscription status.
 * Modes gated by subscription should still be visible (with upsell on click).
 */
export function useIsModeVisible() {
    const { isAvailable: isBrowserAgentSearchModeEnabled } = useBrowserAgentSearchModeEnabled();
    return useCallback((mode) => {
        switch (mode) {
            case SearchMode.BROWSER_AGENT:
                return isBrowserAgentSearchModeEnabled;
            case SearchMode.ASI:
                return true;
            default:
                return true;
        }
    }, [isBrowserAgentSearchModeEnabled]);
}
//# sourceMappingURL=useIsModeVisible.js.map